import React from "react";

export default function TheJourney() {
  return (
    <>
      <div className="tp-award-area pt-125 pb-125">
        <div className="container container-1630">
          {/* 111111111111111111 */}
          <div className="row">
            <div className="col-xl-5 col-lg-5 col-md-12">
              <div className="text-center">
                <img
                  className="roadmap-img"
                  src="assets/img/one/q1.png"
                  alt=""
                />
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="pb-50">
                <h3 className="text-gre-one">Official Kryptogram NFT Launch</h3>
              </div>
              <div className="tp-award-list-wrap">
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>Kryptogram NFT Smart Contracts Finalized & Audited</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p> Whitelist Pre-Sale Begins (Exclusive Early Access)</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p> Public Sale of Kryptogram NFTs (Elite & SuperElite)</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p> Kryptogram Island Land Allocation Strategy Finalized</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>
                      Exclusive Partner Announcements & Strategic Collaborations
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 2222222222222222222 */}

          <div className="row pt-100">
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="pb-50">
                <h3 className="text-gre-one">
                  Tribe O Crypto Festival Preparations
                </h3>
              </div>
              <div className="tp-award-list-wrap">
                <div className="tp-award-list-item d-flex align-items-center justify-content-between active tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>Tribe O Crypto Festival Registration Opens</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>Global Influencer & Brand Partnerships for Promotion</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p> Kryptogram Marketplace Integration for NFT Trading</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>
                      Event Ticketing System Live (Kryptogram NFT = Access Pass)
                    </p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p> VIP & SuperElite Lounge Allocations Finalized</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5 col-md-12">
              <div className="text-center">
                <img
                  className="roadmap-img"
                  src="assets/img/one/q2.png"
                  alt=""
                />
              </div>
            </div>
          </div>

          {/* 3333333333333333333333333333 */}

          <div className="row pt-100">
            <div className="col-xl-5 col-lg-5 col-md-12">
              <div className="text-center">
                <img
                  className="roadmap-img"
                  src="assets/img/one/q3.png"
                  alt=""
                />
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="pb-50">
                <h3 className="text-gre-one">
                  Kryptogram Island Land Distribution & NFT Trading
                </h3>
              </div>
              <div className="tp-award-list-wrap">
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>
                      Kryptogram NFT Trading Opens on Major Marketplaces
                      (OpenSea, Rarible, etc.)
                    </p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p> Land Ownership Verification for NFT Holders</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>Exclusive Kryptogram Island Virtual Map Release</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>
                      SuperElite Holders Receive VIP Packages for Tribe O Crypto
                    </p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>
                      Early Staking & Passive Rewards System Development Begins
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 44444444444444444444444 */}
          <div className="row pt-100">
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="pb-50">
                <h3 className="text-gre-one">
                  Tribe O Crypto Festival & Future Expansions
                </h3>
              </div>
              <div className="tp-award-list-wrap">
                <div className="tp-award-list-item d-flex align-items-center justify-content-between active tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>
                      Tribe O Crypto Festival (October 16-18, 2025, Abu Dhabi)
                    </p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>Land Ownership Deeds Issued to Qualified NFT Holders</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>
                      Future Kryptogram NFT Utilities Announced (Airdrops &
                      Yield Farming)
                    </p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>NFT Staking & Passive Yield Farming Beta Release</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>Expansion Plans for Kryptogram Island Development</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5 col-md-12">
              <div className="text-center">
                <img
                  className="roadmap-img"
                  src="assets/img/one/q4.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          {/* 5555555555555555555555555555555 */}
          <div className="row pt-100">
            <div className="col-xl-5 col-lg-5 col-md-12">
              <div className="text-center">
                <img
                  className="roadmap-img"
                  src="assets/img/one/q1_2026.png"
                  alt=""
                />
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="pb-50">
                <h3 className="text-gre-one">
                  2026 & Beyond – The Evolution of Kryptogram
                </h3>
              </div>
              <div className="tp-award-list-wrap">
                <div className="tp-award-list-item d-flex align-items-center justify-content-between active tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>
                      Kryptogram Island Expansion into Luxury Blockchain Real
                      Estate
                    </p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>Tokenized Real Estate Trading Platform Launch</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>Staking & Yield Farming for Long-Term NFT Holders</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>
                      Exclusive Web3 Investment & Business Hubs on Kryptogram
                      Island
                    </p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center">
                    <p>
                      Development of the Next Wave of Blockchain-Integrated
                      Events
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
